import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { motion } from "motion-v";

interface Props {
  as?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AnimatedItem',
  props: {
    as: { default: "div" }
  },
  setup(__props: any) {



const itemVariants = {
  hidden: {
    opacity: 0,
    y: 10,
    scale: 0.95,
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: "spring",
      stiffness: 350,
      damping: 26,
    },
  },
  exit: {
    opacity: 0,
    scale: 0.9,
    y: -6,
    transition: { duration: 0.15, ease: "easeIn" },
  },
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(motion).component, {
    is: __props.as,
    layout: "",
    variants: itemVariants,
    class: "origin-center"
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["is"]))
}
}

})